// 仕様: 認証状態管理用のRedux Slice
// ユーザー認証、ロード状態、エラー状態を一元管理
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  authInitialized: boolean;
  error: string | null;
  user: {
    uid: string | null;
    email: string | null;
  };
}

const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: false,
  authInitialized: false,
  error: null,
  user: {
    uid: null,
    email: null,
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // 認証開始
    setAuthLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    // 認証初期化完了
    setAuthInitialized: (state, action: PayloadAction<boolean>) => {
      state.authInitialized = action.payload;
    },
    // 認証成功
    setAuthSuccess: (state, action: PayloadAction<{ uid: string; email: string | null }>) => {
      state.isAuthenticated = true;
      state.isLoading = false;
      state.error = null;
      state.user = action.payload;
    },
    // 認証失敗
    setAuthError: (state, action: PayloadAction<string>) => {
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = action.payload;
    },
    // ログアウト
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = {
        uid: null,
        email: null,
      };
      state.error = null;
    },
    // エラークリア
    clearAuthError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setAuthLoading,
  setAuthInitialized,
  setAuthSuccess,
  setAuthError,
  logout,
  clearAuthError,
} = authSlice.actions;

// セレクター
export const selectAuth = (state: RootState) => state.auth;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectAuthLoading = (state: RootState) => state.auth.isLoading;
export const selectAuthInitialized = (state: RootState) => state.auth.authInitialized;
export const selectAuthError = (state: RootState) => state.auth.error;
export const selectAuthUser = (state: RootState) => state.auth.user;

export default authSlice.reducer;
